module.exports = __webpack_public_path__ + "static/media/battery-cable-replacement-red.06cda6bb.svg";